import { Panel } from "components/panels";
import React, { useState } from "react";
import { ButtonTertiary } from "components/Atoms/Button";
import { NewFlightWithAIAssistantModal } from "./new/NewFlightWithAIAssistantModal";
import { PhosphorSparkle } from "components/Atoms/PhosphorIcon";
import { useQueryClient } from "@tanstack/react-query";
import { listTemplateQueryKey } from "components/ListTemplate";

export const AIAssistantPanel = () => {
  const [isNewFlightOpen, setIsNewFlightOpen] = useState(false);

  const queryClient = useQueryClient();

  return <>
    <Panel
      panelClassName="s1_panel"
      title={<div className="flex align-end gap">
        <div style={{ height: 24 }}><PhosphorSparkle iconSize="large" /></div>
        <div className="header-title">What would you like to do?</div>
      </div>}
    >
      <div className="flex gap">
        <ButtonTertiary
          onClick={() => setIsNewFlightOpen(true)}
          label="Import flights"
        />
      </div>
    </Panel>
    <NewFlightWithAIAssistantModal
      isOpen={isNewFlightOpen}
      onClose={() => setIsNewFlightOpen(false)}
      onUploadSuccess={() => {
        queryClient.invalidateQueries({ queryKey: [listTemplateQueryKey, "extractorSession_List"] });
      }}
    />
  </>
}